import React, { useEffect, useRef, useState } from "react";
import { BiSolidBadgeCheck } from "react-icons/bi";
import { FaFilter, FaPlus, FaEye, FaTrash } from "react-icons/fa";
import AddLeadModal from "../components/Modals/LeadModal";
import ShowLeadModal from "../components/Modals/ShowLeadModal";
import FollowupModal from "../components/Modals/FollowupModal";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RiChatFollowUpFill } from "react-icons/ri";
import { MdCallMissedOutgoing } from "react-icons/md";
import MissedFollowupModal from "../components/Modals/MissedFollowupModal";
import AppPagination from "../components/AppPagination";
import DeleteModal from "../components/Modals/DeleteModal";

const Lead = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const menuRef = useRef();

    const handleDelete = () => {
      console.log(deleteId);
  
      setShowDeleteModal(false);
    };
  
    const confirmDelete = () => {
      console.log("Delete ID:", deleteId);
  
      setShowDeleteModal(false);
    };
  
    const [showDeleteModal, setShowDeleteModal] = useState(false);
  
    const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const [loading, setLoading] = useState(true);
  const [showFollowup, setShowFollowup] = useState(false);
  const [showMissedModal, setShowMissedModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const leads = [
    {
      id: 1,
      name: "John Doe",
      mobile: "9876543210",
      status: "New",
      source: "Facebook",
      assigned: "Amit",
    },
    {
      id: 2,
      name: "Aman Sharma",
      mobile: "9123456780",
      status: "Contacted",
      source: "Google",
      assigned: "Ravi",
    },
    {
      id: 3,
      name: "Neha Verma",
      mobile: "9988776655",
      status: "Hot",
      source: "Instagram",
      assigned: "Sonia",
    },
    {
      id: 4,
      name: "Rahul Singh",
      mobile: "9000011111",
      status: "New",
      source: "Website",
      assigned: "Amit",
    },
    {
      id: 5,
      name: "Pooja Meena",
      mobile: "9111122222",
      status: "Cold",
      source: "Facebook",
      assigned: "Ravi",
    },
    {
      id: 6,
      name: "Vikas Yadav",
      mobile: "9333344444",
      status: "Hot",
      source: "Google",
      assigned: "Sonia",
    },
  ];

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = leads.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(leads.length / itemsPerPage);

  const changePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [show, setShow] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  return (
    <div className="lead-page">
      <div className="lead-header ">
        <div className="d-flex align-items-center">
          <h2 className="mb-1">Leads</h2>
        </div>

        <div className="ms-auto d-flex flex-row">
          <div className="d-flex flex-row gap-2">
            <button className="btn btn-dark" onClick={toggleFilter}>
              <FaFilter className="me-1" />
              Filter
            </button>

            <button className="btn btn-primary" onClick={() => setShow(true)}>
              <FaPlus className="me-1" />
              Add Lead
            </button>
            <button
              className="btn btn-primary"
              onClick={() => setShowMenu(!showMenu)}
            >
              <BsThreeDotsVertical className="me-1" />
            </button>

            <div className="position-relative" ref={menuRef}>
              {showMenu && (
                <div className="custom-dropdown-menu shadow">
                  <button
                    className="dropdown-item-custom"
                    onClick={() => setShowFollowup(true)}
                  >
                    <RiChatFollowUpFill />
                    Add Lead Followup
                  </button>

                  <button
                    className="dropdown-item-custom"
                    onClick={() => setShowMissedModal(true)}
                  >
                    <MdCallMissedOutgoing />
                    Lead Missed Followup
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Sales stats ends */}
      </div>

      {showFilter && (
        <div className="card filter-grid">
          <div className="card-body d-flex mb-0 pb-0">
            <select className="w-100">
              <option>Select Lead Platform</option>
            </select>

            <select className="w-100">
              <option>Search By Follow-Up Date</option>
            </select>

            <input
              className="w-100"
              type="text"
              placeholder="Search By Text..."
            />
          </div>
        </div>
      )}

      {/* Filters Section */}
      <div className="card mb-4 filter-grid">
        <div className="card-body">
          <select>
            <option>Created By</option>
          </select>

          <select>
            <option>Assign To</option>
          </select>

          <select>
            <option>Labels</option>
          </select>

          <select>
            <option>Source</option>
          </select>

          <select>
            <option>Status</option>
          </select>

          <input type="text" placeholder="Dog Name" />

          <input type="text" placeholder="Service Package" />

          <input type="text" placeholder="Serial No" />
        </div>
      </div>

      <div className="card mb-4 card-light">
        <div className="card-header">
          <h5 className="card-title">Recent Leads</h5>
        </div>

        <div className="card-body">
          <div className="table-outer border">
            <div className="table-responsive">
              <table className="table m-0 align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Status</th>
                    <th>Source</th>
                    <th>Assigned To</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((lead) => (
                      <tr key={lead.id}>
                        <td>{lead.id}</td>
                        <td>{lead.name}</td>
                        <td>{lead.mobile}</td>
                        <td>
                          <span
                            className={`badge bg-opacity-75 ${
                              lead.status === "New"
                                ? "bg-primary"
                                : lead.status === "Hot"
                                  ? "bg-danger"
                                  : lead.status === "Cold"
                                    ? "bg-secondary"
                                    : lead.status === "Contacted"
                                      ? "bg-success"
                                      : lead.status === "Follow Up"
                                        ? "bg-warning text-dark"
                                        : "bg-dark"
                            }`}
                          >
                            {lead.status}
                          </span>
                        </td>
                        <td>{lead.source}</td>
                        <td>{lead.assigned}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-sm btn-info custum_edit text-white"
                              onClick={() => {
                                setSelectedLead(lead);
                                setShowView(true);
                              }}
                            >
                              <FaEye />
                            </button>

                            <button className="btn btn-sm btn-info custum_danger" onClick={() => {
                                setDeleteId(lead.id);
                                setShowDeleteModal(true);
                              }}>
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pagination */}
          <div className="row mt-2 p-2">
            <div className="col-md-12">
              <AppPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={leads.length}
                itemsPerPage={itemsPerPage}
                onPageChange={changePage}
              />
            </div>
          </div>
        </div>
      </div>

      <AddLeadModal show={show} setShow={setShow} />
      <ShowLeadModal
        showView={showView}
        setShowView={setShowView}
        selectedLead={selectedLead}
      />
      <FollowupModal
        showFollowup={showFollowup}
        setShowFollowup={setShowFollowup}
      />

      <MissedFollowupModal
        showMissedModal={showMissedModal}
        setShowMissedModal={setShowMissedModal}
      />

      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        onConfirm={handleDelete}
        title="Delete Lead"
        message="Are you sure you want to delete this Lead?"
      />
    </div>
  );
};

export default Lead;
